import React from 'react';

import PageObjectTile from '@atlaskit/object/tile/page';
import { type ConfluenceGraphQLContentNode } from '@atlassian/dynamic-cards-search-client';
import { highlightMatchedText } from '@atlassian/dynamic-cards-search-common';

import { type SearchLinkProps } from '../../../../common/ui/search-link';
import { ConfluenceResultMeta } from '../../fetch-recent-views-results/recent-views-result-mapper/confluence-result-meta';

type QuickSearchResultMapperArgs = {
	node?: ConfluenceGraphQLContentNode | null;
};

export const quickSearchResultMapper =
	(inputQuery: string) =>
	({ node }: QuickSearchResultMapperArgs): SearchLinkProps => {
		return {
			title: node?.title || '',
			description: (
				<ConfluenceResultMeta
					resultContentType={node?.type ?? 'page'}
					resultAncestors={node?.confluenceEntity?.ancestors}
					resultSpace={node?.space}
				/>
			),
			icon: <PageObjectTile size="small" label="" />,
			onClick: () => {},
			navigationUrl: node?.url,
			highlightedTitle: highlightMatchedText(node?.title ?? '', inputQuery.split(' '))
				.highlightedTitle,
		};
	};
